<template>
  <div class="expertise-form">
    <!-- Loading state -->
    <div v-if="optionsLoading" class="loading-container">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      <p>Loading form options...</p>
    </div>

    <!-- Form content -->
    <div v-else>
    <!-- TCCC Brand Experience Section - REMOVED -->
    <!-- <form-section title="TCCC Brand Experience">
        <h3 class="expertise-subtitle">Which TCCC brands have you worked with? *</h3>
        <MultiSelectWithOther
          :options="brands"
          :modelValue="normalizedSelectedBrands"
          :otherValue="otherBrandExperience"
          :allowOther="true"
          placeholder="Select brands you've worked with"
          otherPlaceholder="Enter other brand experience"
          @update:modelValue="$emit('toggle-brands', $event)"
          @update:otherValue="$emit('update-other-brand-experience', $event)"
          :error="errors.brands || errors.other_brand_experience"
          :class="{ 'error-state': errors.brands || errors.other_brand_experience }"
        />
        <div v-if="errors.brands || errors.other_brand_experience" class="error-message">
          {{ errors.brands || errors.other_brand_experience }}
          </div>
    </form-section> -->

      <!-- Expertise Areas and Level Section -->
    <form-section title="Your Expertise">
        <!-- Expertise Areas -->
      <div class="form-group">
          <label class="expertise-label">Expertise Areas *</label>
          <p class="expertise-sublabel">Select all areas where you have expertise</p>
          <MultiSelectWithOther
            :options="expertiseAreas"
            :modelValue="normalizedSelectedExpertiseAreas"
            :otherValue="otherExpertise"
            :allowOther="true"
            placeholder="Select your areas of expertise"
            otherPlaceholder="Enter other expertise areas"
            @update:modelValue="$emit('toggle-expertise-areas', $event)"
            @update:otherValue="$emit('update-other-expertise', $event)"
            :error="errors.expertise_areas || errors.other_expertise || errors.expertiseAreas"
            :class="{ 'error-state': errors.expertise_areas || errors.other_expertise || errors.expertiseAreas }"
          />
          <div v-if="errors.expertise_areas || errors.other_expertise || errors.expertiseAreas" class="error-message">
            {{ errors.expertise_areas || errors.other_expertise || errors.expertiseAreas }}
          </div>
      </div>
      
      <!-- Expertise Level -->
      <div class="form-group">
          <label class="expertise-label">Expertise Level *</label>
        <div class="expertise-levels">
          <div 
            v-for="level in expertiseLevels" 
            :key="level.value"
            class="level-card"
              :class="{ 
                selected: expertiseLevel === level.value, 
                'error': errors.expertise_level || errors.expertiseLevel 
              }"
            @click="updateExpertiseLevel(level.value)"
          >
            <div class="level-icon">
                <v-icon size="large">{{ level.icon || 'mdi-star' }}</v-icon>
            </div>
            <div class="level-name">{{ level.name }}</div>
            <div class="level-description">{{ level.description }}</div>
          </div>
        </div>
          <div v-if="errors.expertise_level || errors.expertiseLevel" class="error-message">{{ errors.expertise_level || errors.expertiseLevel }}</div>
      </div>
      
      <!-- Industries -->
      <div class="form-group">
          <label class="expertise-label">Industries you have experience with *</label>
          <p class="expertise-sublabel">Select all industries where you have worked</p>
          <MultiSelectWithOther
            :options="industries"
            :modelValue="normalizedSelectedIndustries"
            :otherValue="otherIndustries"
            :allowOther="true"
            placeholder="Select industries you've worked in"
            otherPlaceholder="Enter other industries"
            @update:modelValue="$emit('toggle-industries', $event)"
            @update:otherValue="$emit('update-other-industries', $event)"
            :error="errors.industries || errors.other_industries"
            :class="{ 'error-state': errors.industries || errors.other_industries }"
          />
          <div v-if="errors.industries || errors.other_industries" class="error-message">
            {{ errors.industries || errors.other_industries }}
          </div>
      </div>
    </form-section>

    <!-- Age Demographics & Geographic Expertise Section -->
    <form-section title="Demographics & Geographic Expertise">
      <!-- Age Demographics Expertise -->
      <div class="form-group">
          <label class="expertise-label">Age Demographics Expertise *</label>
          <p class="expertise-sublabel">Rate your experience working with the following age groups (at least one required)</p>
        
        <!-- General age expertise error message -->
          <div v-if="errors.age_expertise || errors.ageExpertise" class="error-message mb-3">{{ errors.age_expertise || errors.ageExpertise }}</div>
        
          <div class="rating-grid" :class="{ 'error-state': errors.age_expertise || errors.ageExpertise }">
          <div class="rating-card" :class="{ active: ageExpertise.children > 0, 'error': errors.age_expertise_children }">
            <div class="rating-icon">
              <v-icon size="large">mdi-account-school</v-icon>
            </div>
            <div class="rating-title">Young Adults</div>
            <div class="rating-description">18-25 years</div>
            <div class="rating-options">
              <div 
                v-for="level in 3" 
                :key="level"
                class="rating-dot"
                :class="{ active: ageExpertise.children >= level }"
                @click="rateAgeExpertise('children', level)"
              ></div>
            </div>
            <div v-if="errors.age_expertise_children" class="error-message">{{ errors.age_expertise_children }}</div>
          </div>
          
          <div class="rating-card" :class="{ active: ageExpertise.teenagers > 0, 'error': errors.age_expertise_teenagers }">
            <div class="rating-icon">
              <v-icon size="large">mdi-briefcase</v-icon>
            </div>
            <div class="rating-title">Adults</div>
            <div class="rating-description">25-40 years</div>
            <div class="rating-options">
              <div 
                v-for="level in 3" 
                :key="level"
                class="rating-dot"
                :class="{ active: ageExpertise.teenagers >= level }"
                @click="rateAgeExpertise('teenagers', level)"
              ></div>
            </div>
            <div v-if="errors.age_expertise_teenagers" class="error-message">{{ errors.age_expertise_teenagers }}</div>
          </div>
          
          <div class="rating-card" :class="{ active: ageExpertise.adults > 0, 'error': errors.age_expertise_adults }">
            <div class="rating-icon">
              <v-icon size="large">mdi-account-supervisor</v-icon>
            </div>
            <div class="rating-title">Middle-Aged Adults</div>
            <div class="rating-description">40-50 years</div>
            <div class="rating-options">
              <div 
                v-for="level in 3" 
                :key="level"
                class="rating-dot"
                :class="{ active: ageExpertise.adults >= level }"
                @click="rateAgeExpertise('adults', level)"
              ></div>
            </div>
            <div v-if="errors.age_expertise_adults" class="error-message">{{ errors.age_expertise_adults }}</div>
          </div>
          
          <div class="rating-card" :class="{ active: ageExpertise.seniors > 0, 'error': errors.age_expertise_seniors }">
            <div class="rating-icon">
              <v-icon size="large">mdi-account-supervisor-circle</v-icon>
            </div>
            <div class="rating-title">Senior Adults</div>
            <div class="rating-description">50+ years</div>
            <div class="rating-options">
              <div 
                v-for="level in 3" 
                :key="level"
                class="rating-dot"
                :class="{ active: ageExpertise.seniors >= level }"
                @click="rateAgeExpertise('seniors', level)"
              ></div>
            </div>
            <div v-if="errors.age_expertise_seniors" class="error-message">{{ errors.age_expertise_seniors }}</div>
          </div>
        </div>
        <div class="rating-legend">
          <div class="legend-item">
            <div class="legend-dot"></div>
            <div class="legend-text">Low Experience</div>
          </div>
          <div class="legend-item">
            <div class="legend-dot active"></div>
            <div class="legend-text">High Experience</div>
          </div>
        </div>
      </div>
      
      <!-- Geographic Expertise -->
      <div class="form-group">
          <label class="expertise-label">Geographic Expertise *</label>
          <p class="expertise-sublabel">Select regions where you have experience</p>
          <MultiSelectWithOther
            :options="geographicRegions"
            :modelValue="normalizedSelectedGeographic"
            :otherValue="''"
            :allowOther="false"
            placeholder="Select regions where you have expertise"
            @update:modelValue="$emit('toggle-geographic-expertise', $event)"
            :error="errors.geographical_expertise || errors.geographicExpertise"
            :class="{ 'error-state': errors.geographical_expertise || errors.geographicExpertise }"
          />
          <div v-if="errors.geographical_expertise || errors.geographicExpertise" class="error-message">
            {{ errors.geographical_expertise || errors.geographicExpertise }}
        </div>
      </div>
    </form-section>

    <!-- Professional Background Section -->
    <form-section title="Professional Background">
      <div class="form-group">
          <label class="background-label">Rate your experience in the following areas *</label>
          <p class="expertise-sublabel">At least one area must be rated</p>
        
        <!-- General background experience error message -->
          <div v-if="errors.background_experience || errors.backgroundExpertise" class="error-message mb-3">{{ errors.background_experience || errors.backgroundExpertise }}</div>
        
          <div class="background-areas" :class="{ 'error-state': errors.background_experience || errors.backgroundExpertise }">
          <div class="background-area" :class="{ 'error': errors.agency_experience }">
            <div class="area-header">
              <div class="area-icon">
                <v-icon size="large">mdi-office-building</v-icon>
              </div>
              <div class="area-title">Agency Experience</div>
            </div>
            <div class="area-rating">
              <div 
                v-for="n in 5" 
                :key="n"
                class="rating-star"
                :class="{ filled: backgroundData.agency >= n }"
                @click="rateBackground('agency', n)"
              >
                <v-icon size="medium">{{ backgroundData.agency >= n ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
              </div>
            </div>
            <div v-if="errors.agency_experience" class="error-message">{{ errors.agency_experience }}</div>
          </div>
          
          <div class="background-area" :class="{ 'error': errors.academia_experience }">
            <div class="area-header">
              <div class="area-icon">
                <v-icon size="large">mdi-school</v-icon>
              </div>
              <div class="area-title">Academia Experience</div>
            </div>
            <div class="area-rating">
              <div 
                v-for="n in 5" 
                :key="n"
                class="rating-star"
                :class="{ filled: backgroundData.academia >= n }"
                @click="rateBackground('academia', n)"
              >
                <v-icon size="medium">{{ backgroundData.academia >= n ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
              </div>
            </div>
            <div v-if="errors.academia_experience" class="error-message">{{ errors.academia_experience }}</div>
          </div>
          
          <div class="background-area" :class="{ 'error': errors.marketing_experience }">
            <div class="area-header">
              <div class="area-icon">
                <v-icon size="large">mdi-bullhorn</v-icon>
              </div>
              <div class="area-title">Marketing Experience</div>
            </div>
            <div class="area-rating">
              <div 
                v-for="n in 5" 
                :key="n"
                class="rating-star"
                :class="{ filled: backgroundData.marketing >= n }"
                @click="rateBackground('marketing', n)"
              >
                <v-icon size="medium">{{ backgroundData.marketing >= n ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
              </div>
            </div>
            <div v-if="errors.marketing_experience" class="error-message">{{ errors.marketing_experience }}</div>
          </div>
          
          <div class="background-area" :class="{ 'error': errors.market_research_experience }">
            <div class="area-header">
              <div class="area-icon">
                <v-icon size="large">mdi-chart-bar</v-icon>
              </div>
              <div class="area-title">Market Research Experience</div>
            </div>
            <div class="area-rating">
              <div 
                v-for="n in 5" 
                :key="n"
                class="rating-star"
                :class="{ filled: backgroundData.marketResearch >= n }"
                @click="rateBackground('marketResearch', n)"
              >
                <v-icon size="medium">{{ backgroundData.marketResearch >= n ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
              </div>
            </div>
            <div v-if="errors.market_research_experience" class="error-message">{{ errors.market_research_experience }}</div>
          </div>
        </div>
      </div>
      
      <!-- Additional Comments -->
      <div class="form-group">
        <label for="additionalInfo">Anything else you'd like to tell us about your experience? (Optional)</label>
        <textarea
          id="additionalInfo"
          :value="additionalInfo"
          @input="updateAdditionalInfo($event.target.value)"
          class="form-textarea"
          :class="{ 'error': errors.additional_info }"
          placeholder="Share any additional information about your expertise or experience that might be relevant"
          rows="5"
        ></textarea>
        <div v-if="errors.additional_info" class="error-message">{{ errors.additional_info }}</div>
      </div>
    </form-section>
    </div>
  </div>
</template>

<script>
import FormSection from '@/components/common/FormSection.vue';
import MultiSelectWithOther from '@/components/common/MultiSelectWithOther.vue';
import { useToast } from 'vue-toastification';
import apiService from '@/services/apiService';

export default {
  name: 'ExpertiseForm',
  components: {
    FormSection,
    MultiSelectWithOther
  },
  
  setup() {
    const toast = useToast();
    return { toast };
  },
  
  props: {
    // Brand selections - REMOVED (No longer needed)
    // selectedBrands: {
    //   type: Array,
    //   default: () => []
    // },
    // otherBrandExperience: {
    //   type: String,
    //   default: ''
    // },
    
    // Keep for backward compatibility but not used
    selectedBrands: {
      type: Array,
      default: () => []
    },
    otherBrandExperience: {
      type: String,
      default: ''
    },
    
    // Expertise areas
    selectedExpertiseAreas: {
      type: Array,
      default: () => []
    },
    otherExpertise: {
      type: String,
      default: ''
    },
    
    // Industries
    selectedIndustries: {
      type: Array,
      default: () => []
    },
    otherIndustries: {
      type: String,
      default: ''
    },
    
    // Geographic expertise
    selectedGeographicExpertise: {
      type: Array,
      default: () => []
    },
    
    // Expertise level
    expertiseLevel: {
      type: String,
      default: ''
    },
    
    // Rating objects
    ageExpertise: {
      type: Object,
      default: () => ({ children: 0, teenagers: 0, adults: 0, seniors: 0 })
    },
    backgroundData: {
      type: Object,
      default: () => ({ agency: 0, academia: 0, marketing: 0, marketResearch: 0 })
    },
    
    // Additional info
    additionalInfo: {
      type: String,
      default: ''
    },
    
    // Error handling
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  
  computed: {
    /*
      Normalize incoming selected arrays to return arrays of IDs that MultiSelectWithOther
      expects in its modelValue prop. Convert from names, objects, or IDs to consistent ID arrays.
    */
    // COMMENTED OUT - Brand normalization no longer needed
    // normalizedSelectedBrands() {
    //   return this.selectedBrands.map(item => {
    //     if (typeof item === 'number') {
    //       return item; // Already an ID
    //     }
    //     if (typeof item === 'object' && item.id) {
    //       return item.id; // Extract ID from object
    //     }
    //     // Assume item is a string (brand name), find matching ID
    //     const brandObj = this.brands.find(b => b.name.toLowerCase() === String(item).toLowerCase());
    //     return brandObj ? brandObj.id : null;
    //   }).filter(id => id !== null);
    // },
    
    // Keep for backward compatibility
    normalizedSelectedBrands() {
      if (!this.selectedBrands || !Array.isArray(this.selectedBrands)) return [];
      return this.selectedBrands.map(item => {
        if (typeof item === 'number') {
          return item; // Already an ID
        }
        if (typeof item === 'object' && item.id) {
          return item.id; // Extract ID from object
        }
        // Assume item is a string (brand name), find matching ID
        const brandObj = this.brands.find(b => b.name.toLowerCase() === String(item).toLowerCase());
        return brandObj ? brandObj.id : null;
      }).filter(id => id !== null);
    },
    normalizedSelectedIndustries() {
      return this.selectedIndustries.map(item => {
        if (typeof item === 'number') return item;
        if (typeof item === 'object' && item.id) return item.id;
        const obj = this.industries.find(i => i.name.toLowerCase() === String(item).toLowerCase());
        return obj ? obj.id : null;
      }).filter(id => id !== null);
    },
    normalizedSelectedExpertiseAreas() {
      return this.selectedExpertiseAreas.map(item => {
        if (typeof item === 'number') return item;
        if (typeof item === 'object' && item.id) return item.id;
        const obj = this.expertiseAreas.find(e => e.name.toLowerCase() === String(item).toLowerCase());
        return obj ? obj.id : null;
      }).filter(id => id !== null);
    },
    normalizedSelectedGeographic() {
      return this.selectedGeographicExpertise.map(item => {
        if (typeof item === 'number') return item;
        if (typeof item === 'object' && item.id) return item.id;
        const obj = this.geographicRegions.find(r => r.name.toLowerCase() === String(item).toLowerCase());
        return obj ? obj.id : null;
      }).filter(id => id !== null);
    }
  },
  
  data() {
    return {
      // Dynamic data arrays fetched from backend
      industries: [],
      expertiseAreas: [],
      geographicRegions: [],
      brands: [],
      expertiseLevels: [],
      
      // Loading state
      optionsLoading: true
    };
  },
  
  async created() {
    await this.fetchFormOptions();
  },
  
  methods: {
    async fetchFormOptions() {
      try {
        this.optionsLoading = true;
        const response = await apiService.get('/experts/form-options/');
        
        this.industries = response.data.industries || [];
        this.expertiseAreas = response.data.expertiseAreas || [];
        this.geographicRegions = response.data.geographicRegions || [];
        this.brands = response.data.brands || [];
        this.expertiseLevels = response.data.expertiseLevels || [];
        
      } catch (error) {
        console.error('Error fetching form options:', error);
        this.toast.error('Failed to load form options');
        
        // Fallback to static data if API fails
        this.setFallbackData();
      } finally {
        this.optionsLoading = false;
      }
    },
    
    setFallbackData() {
      // Fallback static data in case API fails
      this.industries = [
        { id: 1, name: 'Food & Beverage' },
        { id: 2, name: 'Consumer Goods' },
        { id: 3, name: 'Technology' },
        { id: 4, name: 'Healthcare' },
        { id: 5, name: 'Retail' },
        { id: 6, name: 'Fashion' },
        { id: 7, name: 'Entertainment' },
        { id: 8, name: 'Automotive' },
        { id: 9, name: 'Financial Services' },
        { id: 10, name: 'Hospitality' },
        { id: 11, name: 'Education' },
        { id: 12, name: 'Environment' }
      ];
      
      this.expertiseAreas = [
        { id: 1, name: 'Brand Design' },
        { id: 2, name: 'Brand Identity' },
        { id: 3, name: 'Marketing' },
        { id: 4, name: 'Product Development' },
        { id: 5, name: 'Consumer Insights' },
        { id: 6, name: 'Packaging Engineering' },
        { id: 7, name: 'Research & Development' },
        { id: 8, name: 'Strategy' },
        { id: 9, name: 'Innovation' }
      ];
      
      this.geographicRegions = [
        { id: 1, name: 'North America' },
        { id: 2, name: 'South America' },
        { id: 3, name: 'Europe' },
        { id: 4, name: 'Asia Pacific' },
        { id: 5, name: 'Africa' },
        { id: 6, name: 'Middle East' },
        { id: 7, name: 'Latin America' }
      ];
      
      this.brands = [
        { id: 1, name: 'Coca-Cola' },
        { id: 2, name: 'Sprite' },
        { id: 3, name: 'Fanta' },
        { id: 4, name: 'Powerade' },
        { id: 5, name: 'Minute Maid' },
        { id: 6, name: 'Dasani' },
        { id: 7, name: 'AdeS' },
        { id: 8, name: 'Smartwater' },
        { id: 9, name: 'Topo Chico' },
        { id: 10, name: 'Costa Coffee' },
        { id: 11, name: 'Honest Tea' },
        { id: 12, name: 'Simply' }
      ];
      
      this.expertiseLevels = [
        { 
          value: 'junior', 
          name: 'Junior', 
          icon: 'mdi-lightning-bolt',
          description: '1-3 years of experience'
        },
        { 
          value: 'mid', 
          name: 'Mid-level', 
          icon: 'mdi-star',
          description: '3-5 years of experience'
        },
        { 
          value: 'senior', 
          name: 'Senior', 
          icon: 'mdi-crown',
          description: '5+ years of experience'
        }
      ];
    },
    
    // Helper methods
    isSelected(selectedArray, id) {
      if (!selectedArray || !Array.isArray(selectedArray)) {
        return false;
      }
      return selectedArray.some(item => 
        typeof item === 'object' ? item.id === id : item === id
      );
    },
    
    // Notification methods using vue-toastification
    showSuccess(message) {
      this.toast.success(message);
    },
    
    showError(message) {
      this.toast.error(message);
    },
    
    // Expertise level
    updateExpertiseLevel(level) {
      // Toggle functionality - if clicking the same level, deselect it
      const newLevel = this.expertiseLevel === level ? '' : level;
      this.$emit('update-expertise-level', newLevel);
    },
    
    // Rating methods
    rateAgeExpertise(group, level) {
      // Toggle functionality - if clicking the same level, set to 0
      const currentLevel = this.ageExpertise[group] || 0;
      const newLevel = currentLevel === level ? 0 : level;
      this.$emit('rate-age-expertise', { group, level: newLevel });
    },
    
    rateBackground(area, level) {
      // Toggle functionality - if clicking the same level, set to 0
      const currentLevel = this.backgroundData[area] || 0;
      const newLevel = currentLevel === level ? 0 : level;
      this.$emit('rate-background', { area, level: newLevel });
    },
    
    // Additional info
    updateAdditionalInfo(value) {
      this.$emit('update-additional-info', value);
    }
  }
};
</script>

<style scoped>
.expertise-form {
  width: 100%;
  position: relative;
}

/* Loading Container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
}

.loading-container p {
  margin-top: 16px;
  color: #666;
  font-size: 16px;
}

/* Error Message Styles */
.error-message {
  color: #f44336;
  font-size: 12px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.error-message::before {
  content: '⚠';
  font-size: 12px;
}

/* Error State Styles */
.error-state {
  border: 2px solid #f44336 !important;
  border-radius: 8px;
  background-color: #ffebee;
}

.level-card.error,
.rating-item.error,
.industry-chip.error,
.rating-card.error,
.geo-rating-item.error,
.background-area.error {
  border-color: #f44336 !important;
  background-color: #ffebee;
}

.rating-grid.error-state,
.background-areas.error-state {
  border: 2px solid #f44336;
  border-radius: 8px;
  padding: 15px;
  background-color: #ffebee;
}

/* Required field indicators */
.expertise-label::after,
.background-label::after {
  content: '';
}

.expertise-subtitle::after {
  content: '';
}

/* Add asterisk to required labels */
label:has(+ .expertise-sublabel)::after,
.expertise-label::after,
.background-label::after {
  color: #f44336;
  margin-left: 2px;
}

.expertise-subtitle {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  transition: border-color 0.3s ease;
}

.form-control:focus {
  outline: none;
  border-color: #e94057;
}

/* Brands Container Styles */
.brands-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.brand-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  background: white;
}

.brand-item:hover {
  border-color: #e94057;
  box-shadow: 0 2px 8px rgba(233, 64, 87, 0.1);
}

.brand-item.selected {
  border-color: #e94057;
  background-color: #fef7f7;
}

.brand-logo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  color: white;
  font-weight: bold;
  font-size: 18px;
}

.brand-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.brand-name {
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  color: #333;
}

.brand-checkbox {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  border: 2px solid #e94057;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkbox-inner {
  width: 100%;
  height: 100%;
  background: #e94057;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Specialization and Expertise Styles */
.select-wrapper {
  position: relative;
}

.select-dropdown {
  appearance: none;
  padding-right: 40px;
}

.select-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #666;
}

.expertise-label {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

.expertise-sublabel {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

/* Expertise Level Cards */
.expertise-levels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.level-card {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.level-card:hover {
  border-color: #e94057;
  box-shadow: 0 2px 8px rgba(233, 64, 87, 0.1);
}

.level-card.selected {
  border-color: #e94057;
  background-color: #fef7f7;
}

.level-icon {
  margin-bottom: 10px;
  color: #e94057;
}

.level-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.level-description {
  font-size: 12px;
  color: #666;
}

/* Design Expertise Rating */
.expertise-rating {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.rating-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
}

.rating-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.rating-options {
  display: flex;
  gap: 8px;
}

.rating-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.rating-circle:hover {
  border-color: #e94057;
}

.rating-circle.active {
  background: #e94057;
  color: white;
  border-color: #e94057;
}

/* Industries Container */
.industries-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
}

.industry-chip {
  padding: 8px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.industry-chip:hover {
  border-color: #e94057;
}

.industry-chip.selected {
  background: #e94057;
  color: white;
  border-color: #e94057;
}

/* Age Demographics Rating Grid */
.rating-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.rating-card {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  background: white;
  transition: all 0.3s ease;
}

.rating-card.active {
  border-color: #e94057;
  background-color: #fef7f7;
}

.rating-icon {
  margin-bottom: 10px;
  color: #e94057;
}

.rating-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.rating-description {
  font-size: 12px;
  color: #666;
  margin-bottom: 15px;
}

.rating-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #e0e0e0;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 2px;
}

.rating-dot.active {
  background: #e94057;
}

.rating-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 15px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #e0e0e0;
}

.legend-dot.active {
  background: #e94057;
}

.legend-text {
  font-size: 12px;
  color: #666;
}

/* Geographic Expertise */
.geo-container {
  margin-top: 20px;
}

.geo-ratings {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.geo-rating-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
}

.geo-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.geo-rating-options {
  display: flex;
  gap: 8px;
}

.geo-rating-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #e0e0e0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.geo-rating-dot.active {
  background: #e94057;
}

/* Professional Background */
.background-label {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  display: block;
}

.background-areas {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.background-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  background: white;
}

.area-header {
  display: flex;
  align-items: center;
  gap: 15px;
}

.area-icon {
  color: #e94057;
}

.area-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.area-rating {
  display: flex;
  gap: 5px;
}

.rating-star {
  cursor: pointer;
  transition: all 0.3s ease;
  color: #e0e0e0;
}

.rating-star.filled {
  color: #ffd700;
}

.rating-star:hover {
  transform: scale(1.1);
}

/* Form Textarea */
.form-textarea {
  width: 100%;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  min-height: 120px;
  transition: border-color 0.3s ease;
}

.form-textarea:focus {
  outline: none;
  border-color: #e94057;
}

.mt-2 {
  margin-top: 8px;
}

.mb-3 {
  margin-bottom: 16px;
}
</style> 